const GOOGLE_LENS_COUNTRIES = [
  {
    country_code: 'ae',
    country: 'United Arab Emirates',
    is_shopping_supported: true,
  },
  {
    country_code: 'af',
    country: 'Afghanistan',
    is_shopping_supported: false,
  },
  {
    country_code: 'ag',
    country: 'Antigua and Barbuda',
    is_shopping_supported: false,
  },
  {
    country_code: 'ai',
    country: 'Anguilla',
    is_shopping_supported: false,
  },
  {
    country_code: 'al',
    country: 'Albania',
    is_shopping_supported: false,
  },
  {
    country_code: 'am',
    country: 'Armenia',
    is_shopping_supported: false,
  },
  {
    country_code: 'ao',
    country: 'Angola',
    is_shopping_supported: false,
  },
  {
    country_code: 'ar',
    country: 'Argentina',
    is_shopping_supported: false,
  },
  {
    country_code: 'at',
    country: 'Austria',
    is_shopping_supported: true,
  },
  {
    country_code: 'au',
    country: 'Australia',
    is_shopping_supported: true,
  },
  {
    country_code: 'aw',
    country: 'Aruba',
    is_shopping_supported: false,
  },
  {
    country_code: 'az',
    country: 'Azerbaijan',
    is_shopping_supported: false,
  },
  {
    country_code: 'ba',
    country: 'Bosnia and Herzegovina',
    is_shopping_supported: false,
  },
  {
    country_code: 'bb',
    country: 'Barbados',
    is_shopping_supported: false,
  },
  {
    country_code: 'bd',
    country: 'Bangladesh',
    is_shopping_supported: false,
  },
  {
    country_code: 'be',
    country: 'Belgium',
    is_shopping_supported: true,
  },
  {
    country_code: 'bg',
    country: 'Bulgaria',
    is_shopping_supported: false,
  },
  {
    country_code: 'bh',
    country: 'Bahrain',
    is_shopping_supported: false,
  },
  {
    country_code: 'bj',
    country: 'Benin',
    is_shopping_supported: false,
  },
  {
    country_code: 'bn',
    country: 'Brunei Darussalam',
    is_shopping_supported: false,
  },
  {
    country_code: 'bo',
    country: 'Bolivia',
    is_shopping_supported: false,
  },
  {
    country_code: 'br',
    country: 'Brazil',
    is_shopping_supported: true,
  },
  {
    country_code: 'bs',
    country: 'Bahamas',
    is_shopping_supported: false,
  },
  {
    country_code: 'bw',
    country: 'Botswana',
    is_shopping_supported: false,
  },
  {
    country_code: 'by',
    country: 'Belarus',
    is_shopping_supported: false,
  },
  {
    country_code: 'bz',
    country: 'Belize',
    is_shopping_supported: false,
  },
  {
    country_code: 'ca',
    country: 'Canada',
    is_shopping_supported: true,
  },
  {
    country_code: 'cg',
    country: 'Congo',
    is_shopping_supported: false,
  },
  {
    country_code: 'ch',
    country: 'Switzerland',
    is_shopping_supported: true,
  },
  {
    country_code: 'ci',
    country: 'Ivory Coast',
    is_shopping_supported: false,
  },
  {
    country_code: 'cl',
    country: 'Chile',
    is_shopping_supported: true,
  },
  {
    country_code: 'cm',
    country: 'Cameroon',
    is_shopping_supported: false,
  },
  {
    country_code: 'cn',
    country: 'China',
    is_shopping_supported: false,
  },
  {
    country_code: 'co',
    country: 'Colombia',
    is_shopping_supported: true,
  },
  {
    country_code: 'cr',
    country: 'Costa Rica',
    is_shopping_supported: false,
  },
  {
    country_code: 'cv',
    country: 'Cape Verde',
    is_shopping_supported: false,
  },
  {
    country_code: 'cy',
    country: 'Cyprus',
    is_shopping_supported: false,
  },
  {
    country_code: 'cz',
    country: 'Czech Republic',
    is_shopping_supported: true,
  },
  {
    country_code: 'de',
    country: 'Germany',
    is_shopping_supported: true,
  },
  {
    country_code: 'dk',
    country: 'Denmark',
    is_shopping_supported: true,
  },
  {
    country_code: 'do',
    country: 'Dominican Republic',
    is_shopping_supported: false,
  },
  {
    country_code: 'dz',
    country: 'Algeria',
    is_shopping_supported: false,
  },
  {
    country_code: 'ec',
    country: 'Ecuador',
    is_shopping_supported: false,
  },
  {
    country_code: 'ee',
    country: 'Estonia',
    is_shopping_supported: false,
  },
  {
    country_code: 'eg',
    country: 'Egypt',
    is_shopping_supported: false,
  },
  {
    country_code: 'es',
    country: 'Spain',
    is_shopping_supported: true,
  },
  {
    country_code: 'et',
    country: 'Ethiopia',
    is_shopping_supported: false,
  },
  {
    country_code: 'fi',
    country: 'Finland',
    is_shopping_supported: false,
  },
  {
    country_code: 'fr',
    country: 'France',
    is_shopping_supported: true,
  },
  {
    country_code: 'gb',
    country: 'United Kingdom',
    is_shopping_supported: true,
  },
  {
    country_code: 'ge',
    country: 'Georgia',
    is_shopping_supported: false,
  },
  {
    country_code: 'gh',
    country: 'Ghana',
    is_shopping_supported: false,
  },
  {
    country_code: 'gp',
    country: 'Guadeloupe',
    is_shopping_supported: false,
  },
  {
    country_code: 'gr',
    country: 'Greece',
    is_shopping_supported: false,
  },
  {
    country_code: 'gt',
    country: 'Guatemala',
    is_shopping_supported: false,
  },
  {
    country_code: 'gy',
    country: 'Guyana',
    is_shopping_supported: false,
  },
  {
    country_code: 'hk',
    country: 'Hong Kong',
    is_shopping_supported: false,
  },
  {
    country_code: 'hn',
    country: 'Honduras',
    is_shopping_supported: false,
  },
  {
    country_code: 'hr',
    country: 'Croatia',
    is_shopping_supported: false,
  },
  {
    country_code: 'ht',
    country: 'Haiti',
    is_shopping_supported: false,
  },
  {
    country_code: 'hu',
    country: 'Hungary',
    is_shopping_supported: false,
  },
  {
    country_code: 'id',
    country: 'Indonesia',
    is_shopping_supported: true,
  },
  {
    country_code: 'ie',
    country: 'Ireland',
    is_shopping_supported: true,
  },
  {
    country_code: 'il',
    country: 'Israel',
    is_shopping_supported: false,
  },
  {
    country_code: 'in',
    country: 'India',
    is_shopping_supported: true,
  },
  {
    country_code: 'iq',
    country: 'Iraq',
    is_shopping_supported: false,
  },
  {
    country_code: 'is',
    country: 'Iceland',
    is_shopping_supported: false,
  },
  {
    country_code: 'it',
    country: 'Italy',
    is_shopping_supported: true,
  },
  {
    country_code: 'jm',
    country: 'Jamaica',
    is_shopping_supported: false,
  },
  {
    country_code: 'jo',
    country: 'Jordan',
    is_shopping_supported: false,
  },
  {
    country_code: 'jp',
    country: 'Japan',
    is_shopping_supported: true,
  },
  {
    country_code: 'ke',
    country: 'Kenya',
    is_shopping_supported: false,
  },
  {
    country_code: 'kg',
    country: 'Kyrgyzstan',
    is_shopping_supported: false,
  },
  {
    country_code: 'kh',
    country: 'Cambodia',
    is_shopping_supported: false,
  },
  {
    country_code: 'kr',
    country: 'Korea, Republic of',
    is_shopping_supported: true,
  },
  {
    country_code: 'kw',
    country: 'Kuwait',
    is_shopping_supported: false,
  },
  {
    country_code: 'ky',
    country: 'Cayman Islands',
    is_shopping_supported: false,
  },
  {
    country_code: 'kz',
    country: 'Kazakhstan',
    is_shopping_supported: false,
  },
  {
    country_code: 'la',
    country: "Lao People's Democratic Republic",
    is_shopping_supported: false,
  },
  {
    country_code: 'lb',
    country: 'Lebanon',
    is_shopping_supported: false,
  },
  {
    country_code: 'lc',
    country: 'Saint Lucia',
    is_shopping_supported: false,
  },
  {
    country_code: 'lk',
    country: 'Sri Lanka',
    is_shopping_supported: false,
  },
  {
    country_code: 'lt',
    country: 'Lithuania',
    is_shopping_supported: false,
  },
  {
    country_code: 'lu',
    country: 'Luxembourg',
    is_shopping_supported: false,
  },
  {
    country_code: 'lv',
    country: 'Latvia',
    is_shopping_supported: false,
  },
  {
    country_code: 'ly',
    country: 'Libya',
    is_shopping_supported: false,
  },
  {
    country_code: 'ma',
    country: 'Morocco',
    is_shopping_supported: false,
  },
  {
    country_code: 'md',
    country: 'Moldova',
    is_shopping_supported: false,
  },
  {
    country_code: 'me',
    country: 'Montenegro',
    is_shopping_supported: false,
  },
  {
    country_code: 'mg',
    country: 'Madagascar',
    is_shopping_supported: false,
  },
  {
    country_code: 'mk',
    country: 'Macedonia',
    is_shopping_supported: false,
  },
  {
    country_code: 'ml',
    country: 'Mali',
    is_shopping_supported: false,
  },
  {
    country_code: 'mm',
    country: 'Myanmar',
    is_shopping_supported: false,
  },
  {
    country_code: 'mn',
    country: 'Mongolia',
    is_shopping_supported: false,
  },
  {
    country_code: 'mo',
    country: 'Macau',
    is_shopping_supported: false,
  },
  {
    country_code: 'mq',
    country: 'Martinique',
    is_shopping_supported: false,
  },
  {
    country_code: 'mt',
    country: 'Malta',
    is_shopping_supported: false,
  },
  {
    country_code: 'mu',
    country: 'Mauritius',
    is_shopping_supported: false,
  },
  {
    country_code: 'mv',
    country: 'Maldives',
    is_shopping_supported: false,
  },
  {
    country_code: 'mx',
    country: 'Mexico',
    is_shopping_supported: true,
  },
  {
    country_code: 'my',
    country: 'Malaysia',
    is_shopping_supported: true,
  },
  {
    country_code: 'mz',
    country: 'Mozambique',
    is_shopping_supported: false,
  },
  {
    country_code: 'na',
    country: 'Namibia',
    is_shopping_supported: false,
  },
  {
    country_code: 'nc',
    country: 'New Caledonia',
    is_shopping_supported: false,
  },
  {
    country_code: 'ng',
    country: 'Nigeria',
    is_shopping_supported: false,
  },
  {
    country_code: 'ni',
    country: 'Nicaragua',
    is_shopping_supported: false,
  },
  {
    country_code: 'nl',
    country: 'Netherlands',
    is_shopping_supported: true,
  },
  {
    country_code: 'no',
    country: 'Norway',
    is_shopping_supported: true,
  },
  {
    country_code: 'np',
    country: 'Nepal',
    is_shopping_supported: false,
  },
  {
    country_code: 'nz',
    country: 'New Zealand',
    is_shopping_supported: true,
  },
  {
    country_code: 'om',
    country: 'Oman',
    is_shopping_supported: false,
  },
  {
    country_code: 'pa',
    country: 'Panama',
    is_shopping_supported: false,
  },
  {
    country_code: 'pe',
    country: 'Peru',
    is_shopping_supported: false,
  },
  {
    country_code: 'ph',
    country: 'Philippines',
    is_shopping_supported: true,
  },
  {
    country_code: 'pk',
    country: 'Pakistan',
    is_shopping_supported: false,
  },
  {
    country_code: 'pl',
    country: 'Poland',
    is_shopping_supported: true,
  },
  {
    country_code: 'pr',
    country: 'Puerto Rico',
    is_shopping_supported: false,
  },
  {
    country_code: 'ps',
    country: 'Palestine',
    is_shopping_supported: false,
  },
  {
    country_code: 'pt',
    country: 'Portugal',
    is_shopping_supported: true,
  },
  {
    country_code: 'py',
    country: 'Paraguay',
    is_shopping_supported: false,
  },
  {
    country_code: 'qa',
    country: 'Qatar',
    is_shopping_supported: false,
  },
  {
    country_code: 're',
    country: 'Reunion',
    is_shopping_supported: false,
  },
  {
    country_code: 'ro',
    country: 'Romania',
    is_shopping_supported: false,
  },
  {
    country_code: 'rs',
    country: 'Serbia',
    is_shopping_supported: false,
  },
  {
    country_code: 'ru',
    country: 'Russia',
    is_shopping_supported: true,
  },
  {
    country_code: 'sa',
    country: 'Saudi Arabia',
    is_shopping_supported: false,
  },
  {
    country_code: 'sc',
    country: 'Seychelles',
    is_shopping_supported: false,
  },
  {
    country_code: 'sd',
    country: 'Sudan',
    is_shopping_supported: false,
  },
  {
    country_code: 'se',
    country: 'Sweden',
    is_shopping_supported: true,
  },
  {
    country_code: 'sg',
    country: 'Singapore',
    is_shopping_supported: true,
  },
  {
    country_code: 'si',
    country: 'Slovenia',
    is_shopping_supported: false,
  },
  {
    country_code: 'sk',
    country: 'Slovakia',
    is_shopping_supported: false,
  },
  {
    country_code: 'sn',
    country: 'Senegal',
    is_shopping_supported: false,
  },
  {
    country_code: 'sr',
    country: 'Suriname',
    is_shopping_supported: false,
  },
  {
    country_code: 'sv',
    country: 'El Salvador',
    is_shopping_supported: false,
  },
  {
    country_code: 'th',
    country: 'Thailand',
    is_shopping_supported: false,
  },
  {
    country_code: 'tn',
    country: 'Tunisia',
    is_shopping_supported: false,
  },
  {
    country_code: 'tr',
    country: 'Turkey',
    is_shopping_supported: true,
  },
  {
    country_code: 'tt',
    country: 'Trinidad and Tobago',
    is_shopping_supported: false,
  },
  {
    country_code: 'tw',
    country: 'Taiwan',
    is_shopping_supported: false,
  },
  {
    country_code: 'tz',
    country: 'Tanzania',
    is_shopping_supported: false,
  },
  {
    country_code: 'ua',
    country: 'Ukraine',
    is_shopping_supported: false,
  },
  {
    country_code: 'ug',
    country: 'Uganda',
    is_shopping_supported: false,
  },
  {
    country_code: 'us',
    country: 'United States',
    is_shopping_supported: true,
  },
  {
    country_code: 'uy',
    country: 'Uruguay',
    is_shopping_supported: false,
  },
  {
    country_code: 'uz',
    country: 'Uzbekistan',
    is_shopping_supported: false,
  },
  {
    country_code: 'vc',
    country: 'Saint Vincent and the Grenadines',
    is_shopping_supported: false,
  },
  {
    country_code: 've',
    country: 'Venezuela',
    is_shopping_supported: false,
  },
  {
    country_code: 'vn',
    country: 'Vietnam',
    is_shopping_supported: false,
  },
  {
    country_code: 'xk',
    country: 'Kosovo',
    is_shopping_supported: false,
  },
  {
    country_code: 'ye',
    country: 'Yemen',
    is_shopping_supported: false,
  },
  {
    country_code: 'za',
    country: 'South Africa',
    is_shopping_supported: true,
  },
  {
    country_code: 'zm',
    country: 'Zambia',
    is_shopping_supported: false,
  },
  {
    country_code: 'zw',
    country: 'Zimbabwe',
    is_shopping_supported: false,
  },
]

// Only include countries that are supported for shopping
export default GOOGLE_LENS_COUNTRIES.filter((c) => c.is_shopping_supported)
